import { parseNumberArg, parseStringArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'admin/list',
    name: 'admin-list',
    meta: { title: '管理员列表', componentName: 'AdminList' },
    component: () => import('@/views/mb/account/AdminList.vue'),
    props: true
  },
  {
    path: 'admin/:adminId(\\d+)',
    name: 'admin-info',
    meta: { title: '管理员信息', componentName: 'AdminInfo' },
    component: () => import('@/views/mb/account/AdminInfo.vue'),
    props: (to) => ({ adminId: parseNumberArg(to.params.adminId) })
  },
  {
    path: 'admin/phone',
    name: 'admin-phone',
    meta: { title: '管理员手机号', componentName: 'AdminPhone' },
    component: () => import('@/views/mb/account/AdminPhone.vue')
  },
  {
    path: 'admin/password',
    name: 'admin-password',
    meta: { title: '管理员密码', componentName: 'AdminPassword' },
    component: () => import('@/views/mb/account/AdminPassword.vue')
  },
  {
    path: 'user/list',
    name: 'user-list',
    meta: { title: '用户列表', componentName: 'UserList' },
    component: () => import('@/views/mb/account/UserList.vue'),
    props: true
  },
  {
    path: 'user/:userId(\\d+)',
    name: 'user-info',
    meta: { title: '用户信息', componentName: 'UserInfo' },
    component: () => import('@/views/mb/account/UserInfo.vue'),
    props: (to) => ({ userId: parseNumberArg(to.params.userId) })
  },
  {
    path: 'provider/list',
    name: 'provider-list',
    meta: { title: '服务商列表', componentName: 'ProviderList' },
    component: () => import('@/views/mb/account/ProviderList.vue'),
    props: true
  },
  {
    path: 'provider/:providerId(\\d+)',
    name: 'provider-info',
    meta: { title: '服务商信息', componentName: 'ProviderInfo' },
    component: () => import('@/views/mb/account/ProviderInfo.vue'),
    props: (to) => ({ providerId: parseNumberArg(to.params.providerId) })
  },
  {
    path: 'provider/:providerId(\\d+)/skill',
    name: 'provider-skill-list',
    meta: { title: '能力列表', componentName: 'SkillList' },
    component: () => import('@/views/mb/account/SkillList.vue'),
    props: (to) => ({ providerId: parseNumberArg(to.params.providerId) })
  },
  {
    path: 'skill/list/:categoryId(\\d+)?',
    name: 'skill-list',
    meta: { title: '能力列表', componentName: 'SkillList' },
    component: () => import('@/views/mb/account/SkillList.vue'),
    props: (to) => ({ categoryId: parseNumberArg(to.params.categoryId) })
  },
  {
    path: 'skill/:skillId(\\d+)',
    name: 'skill-info',
    meta: { title: '能力信息', componentName: 'SkillInfo' },
    component: () => import('@/views/mb/account/SkillInfo.vue'),
    props: (to) => ({ skillId: parseNumberArg(to.params.skillId), categoryId: parseNumberArg(to.query.categoryId) })
  },
  {
    path: 'employee/list',
    name: 'employee-list',
    meta: { title: '员工列表', componentName: 'EmployeeList' },
    component: () => import('@/views/mb/account/EmployeeList.vue'),
    props: true
  },
  {
    path: 'employee/:merchantId(\\d+)/list',
    name: 'merchant-employee-list',
    meta: { title: '员工列表', componentName: 'EmployeeList' },
    component: () => import('@/views/mb/account/EmployeeList.vue'),
    props: (to) => ({ merchantId: parseNumberArg(to.params.merchantId) })
  },
  {
    path: 'employee/:employeeId(\\d+)',
    name: 'employee-info',
    meta: { title: '员工信息', componentName: 'EmployeeInfo' },
    component: () => import('@/views/mb/account/EmployeeInfo.vue'),
    props: (to) => ({
      employeeId: parseNumberArg(to.params.employeeId),
      merchantId: parseNumberArg(to.query.merchantId)
    })
  },
  {
    path: 'album/list/:ownerType',
    name: 'album-list',
    meta: { title: '相册列表', componentName: 'AlbumList' },
    component: () => import('@/views/mb/account/AlbumList.vue'),
    props: (to) => ({
      ownerId: parseNumberArg(to.query.ownerId),
      ownerType: parseStringArg(to.params.ownerType, 'upper')
    })
  },
  {
    path: 'schedule',
    name: 'schedule',
    meta: { title: '排班', componentName: 'ScheduleSetting' },
    component: () => import('@/views/mb/account/ScheduleSetting.vue'),
    props: (to) => ({
      ownerId: parseNumberArg(to.query.ownerId),
      ownerType: parseStringArg(to.query.ownerType, 'upper')
    })
  }
] as RouteRecordRaw[]
